import { render, staticRenderFns } from "./detail_local_delivery.vue?vue&type=template&id=9e7a229e&scoped=true"
import script from "./detail_local_delivery.vue?vue&type=script&lang=js"
export * from "./detail_local_delivery.vue?vue&type=script&lang=js"
import style0 from "./detail_local_delivery.vue?vue&type=style&index=0&id=9e7a229e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e7a229e",
  null
  
)

export default component.exports